
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import buscador from './buscador.vue';
    import item from './ayuda-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            item
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        async mounted()
        {
            await this.Controlador.Iniciar();

            this.Refrescar();
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public AyudaSeleccionada: any = null;
        public AyudaAbierto: boolean = false;
        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


        public Abrir(item: any)
        {
            console.log(item );
            this.AyudaSeleccionada = item;
            this.AyudaAbierto = !this.AyudaAbierto;
        }
    }
